// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"styles_sectionWrapper__4WTUD","contentWrapper":"styles_contentWrapper__Ljc8a"};